<template>
  <main>
    <Transition name="fade">
      <div v-if="news">
        <ShowHeader :return-label="$t('news.return')" :return-route="{name: $routes.NEWS.INDEX}" :title="news.title"/>
        <PageSections :sections="sections"/>
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {useNewsStore, usePageStore} from '@/stores'
import {PageSections, ShowHeader} from '@/components/sections'

export default {
  name: 'NewsShow',
  mixins: [ViewDataMixin],
  components: {PageSections, ShowHeader},
  data() {
    return {
      news: null as News | null
    }
  },
  computed: {
    sections() {
      if (!this.news) return []

      let sections = [{
        background: 'white' as background,
        buttons: [],
        content: this.news.content,
        flexKey: 'rich-text-content',
        flexLayout: 'rich-text-section' as sectionType
      }] as RepeatableSection[]

      if (this.news.sections) {
        sections = sections.concat(this.news.sections)
      }

      return sections
    }
  },
  watch: {
    async '$i18n.locale'(newLocale: 'en' | 'fr') {
      if (!this.news) return

      const newSlug = this.news.slug[newLocale]

      if (newSlug && newSlug !== this.$route.params.slug) {
        const newsStore = useNewsStore()

        const news = await newsStore.get(newSlug)

        if (news) {
          this.news = news

          await this.$router.replace({
            name: `${this.$routes.NEWS.SHOW}:${newLocale}`,
            params: { slug: newSlug }
          })
        }
      }
    }
  },
  methods: {
    async init() {
      const news = await useNewsStore().get(this.$route.params.slug.toString())

      if (!news) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.news = news
      await this.prefetchIndex()
    },
    async prefetchIndex() {
      await useNewsStore().all()
      await usePageStore().get('news')
    }
  }
}
</script>
